import apiService from "./apiService";
import AppConstants from "../appConstants";

class SendmailService {
    getall(params) {
        return new Promise((resolve, reject) => {
            apiService.get(AppConstants.URL_SENDMAIL, params)
                .then(response => resolve(response))
                .catch(error => reject(error));
        });
    }

    report(params) {
        return new Promise((resolve, reject) => {
            apiService.downloadFile(AppConstants.URL_SENDMAIL_REPORT, params)
                .then(response => resolve(response))
                .catch(error => reject(error));
        });
    }

    forceSend(id) {
        return new Promise((resolve, reject) => {
            apiService.post(`${AppConstants.URL_SENDMAIL_FORCE_SEND}/${id}/force-send`, {})
                .then(response => resolve(response))
                .catch(error => reject(error));
        });
    }

    // =====================================================================
    
}

export default new SendmailService();
